export namespace BodyScroll {
  export function enable() {
    document.body.classList.remove("overflow-hidden");
  }

  export function disable() {
    document.body.classList.add("overflow-hidden");
  }
}
